import React, { useMemo } from 'react';
import { SchemaSelectionComponent } from 'apps/sigma2-ui/src/data-wizard/lib/SchemaSelectionComponent';
import { SchemaSelectionComponentItem } from 'apps/sigma2-ui/src/data-wizard/lib/SchemaSelectionComponent';
import { Phrases } from 'libs/end-to-end/src/phrases';
import { SimpleInput } from 'apps/sigma2-ui/src/components/ui/SimpleInput';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { getPhrasesWithoutParams } from 'libs/end-to-end/src/phrase-utils';
import { tryTranslateDynamic } from 'libs/end-to-end/src/phrase-utils';
import { uiAppLogger } from 'apps/sigma2-ui/src/lib/logging';
import { getTranslatedContentAsString } from 'libs/end-to-end/src/translation-content';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';

export type TranslationSelectionComponentProps = {
  value: string | undefined;
  onChange: (value: string) => void;
  customValue?: string | undefined;
  onCustomValueChange?: (value: string) => void;
};

const CUSTOM_TRANSLATION_KEY = 'dangerousUserInput';

export const TranslationSelectionComponent = ({
  value,
  onChange,
  customValue,
  onCustomValueChange,
}: TranslationSelectionComponentProps) => {
  const language = useLanguage();

  const translationsWoParams: [string, string][] = useMemo(() => {
    const phrases = getPhrasesWithoutParams(language);

    return phrases.map((phrase) => {
      return [
        phrase,
        getTranslatedContentAsString(
          tryTranslateDynamic({
            phrase,
            language,
            customValue: '',
            logger: uiAppLogger,
          }),
        ),
      ];
    });
  }, [language]);

  const mappedTranslations = useMemo(() => {
    const options: SchemaSelectionComponentItem<string>[] =
      translationsWoParams.map(([t, tEn]) => ({
        optionKey: t,
        optionValue: t,
        optionLabel: tEn,
      }));

    if (onCustomValueChange) {
      options.push({
        optionKey: CUSTOM_TRANSLATION_KEY,
        optionValue: CUSTOM_TRANSLATION_KEY,
        optionLabel: 'Custom',
      });
    }

    return options;
  }, [translationsWoParams, onCustomValueChange]);

  return (
    <div className="[&>select]:max-w-52 flex flex-col gap-2">
      <SchemaSelectionComponent
        possibleValues={mappedTranslations}
        selectedValueKey={value ?? null}
        setSelectedValue={(_, value) => {
          if (value) {
            onChange(value);
          }
        }}
      />

      {value === CUSTOM_TRANSLATION_KEY && onCustomValueChange && (
        <SimpleInput
          label=""
          value={customValue ?? ''}
          disabled={false}
          onChange={onCustomValueChange}
        />
      )}
    </div>
  );
};
